import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';

/**
 * Ruta comodín. No existía: Hosting reescribe TODO a index.html, así que cualquier URL que
 * no fuera una ruta conocida (una liga vieja, un dedazo, o `/buen-fin` desde que se retiró)
 * cargaba la app y dejaba el contenido VACÍO entre la barra y el pie.
 */
const NotFound: React.FC = () => (
    <Stack spacing={2.5} alignItems="center" justifyContent="center" sx={{ minHeight: '55vh', px: 2 }}>
        <SearchOffOutlinedIcon sx={{ fontSize: 56, color: 'text.disabled' }} />
        <Typography variant="h5" textAlign="center">
            No encontramos esta página
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ maxWidth: 420 }}>
            La liga puede haber cambiado o ya no está disponible. Si llegaste desde el enlace de tu ticket, revisa el
            mensaje que te enviamos por WhatsApp.
        </Typography>
        <Button component={Link} to="/" variant="contained">
            Ir al inicio
        </Button>
    </Stack>
);

export default NotFound;
